import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { DataGrid, } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useNightMode } from "../../../contexts/NightModeContext";
import { isMobile } from "../../../utils/utils";

type NormalTableProps = {
  columns: {
    key: string;
    label: string;
    cellContent?: (row: any) => React.ReactNode;
    width?: number;
    pinned?: 'left' | 'right';
    hide?: boolean;
  }[];
  data: any[];
  isAllowEdit?: boolean;
  isAllowDelete?: boolean;
  getRowId?: (row: any) => string;
  columnFilters?: Record<string, string>;
  setColumnFilters?: React.Dispatch<
  React.SetStateAction<Record<string, string>>
  >;
  selectedContacts?: string[];
  handleSelectContact?: (id: string) => void;
};

type Column = {
  field: string;
  headerName: string;
  width?: number;
  renderCell?: (params: any) => React.ReactNode;
};


const NormalTable = (props: NormalTableProps) => {

 const {
  columns,
  data,
  isAllowEdit = false,
  isAllowDelete = false,
  getRowId,
  selectedContacts = [],
  handleSelectContact,
} = props;

  const [dataGridColumns, setDataGridColumns] = useState<Column[]>([]);
  const { isNightMode } = useNightMode();

  // Calculate dynamic height based on data length
  // Each row is approximately 60px (including padding and borders)
  // Add 120px for header and footer
  const rowHeight = 60;
  const headerFooterHeight = 120;
  const minHeight = isMobile() ? 200 : 400; // Minimum height for empty or small datasets
  const maxHeight = isMobile() ? 400 : 800; // Maximum height to prevent excessive scrolling
  const dynamicHeight = Math.min(
    Math.max(data.length * rowHeight + headerFooterHeight, minHeight),
    maxHeight
  );

  // Create dynamic theme based on night mode state
  const theme = createTheme({
    palette: {
      mode: isNightMode ? 'dark' : 'light',
    },
  });


 useEffect(() => {
  let columns2: Column[] = columns.map((column) => ({
    field: column.key,
    headerName: column.label,
    width: column?.width ?? 200,
    pinned: column?.pinned,
    hide: column?.hide,
      renderHeader: () => (
        <div style={{ display: "flex", flexDirection: "column" }}>
          <span>{column.label}</span>
          {props.setColumnFilters && (
            <input
              type="text"
              value={props.columnFilters?.[column.key] || ""}
              onChange={(e) =>
                props.setColumnFilters?.((prev) => ({
                  ...prev,
                  [column.key]: e.target.value,
                }))
              }
              placeholder="Search..."
              style={{
                marginTop: 4,
                padding: "4px 6px",
                fontSize: 12,
                borderRadius: 4,
                border: "1px solid #ccc",
              }}
            />
          )}
        </div>
      ),
    renderCell: column.cellContent
      ? (params) => column.cellContent?.(params.row)
      : undefined,
  }));

  const checkboxColumn: Column = {
    field: "select",
    headerName: "",
    width: 50,
    renderCell: (params) => (
      <input
        type="checkbox"
        checked={selectedContacts?.includes(params.row.contactId)}
        onChange={() => handleSelectContact?.(params.row.contactId)}
      />
    ),
  };

  setDataGridColumns([checkboxColumn, ...columns2]);
}, [columns, selectedContacts, handleSelectContact, props.columnFilters]);



    return (
    <div className="table-card mt-4">
      <div className="main-table">
        <div className="table-responsive">
          <ThemeProvider theme={theme}>
            <div style={{ height: dynamicHeight, width: '100%', overflowX: 'auto' }}>
              <DataGrid
                rows={data}
                columns={dataGridColumns}
                getRowId={getRowId}
                getRowHeight={() => 'auto'}
                sx={{
                  color: isNightMode ? 'white' : 'black',
                  borderColor: isNightMode ? '#333' : '#e0e0e0',
                  '& .MuiDataGrid-cell': {
                    borderBottom: isNightMode ? '1px solid #333' : '1px solid #e0e0e0',
                    alignItems: 'flex-start',
                    padding: '16px',
                    whiteSpace: 'normal',
                    overflow: 'visible',
                  },
                  '& .MuiDataGrid-columnHeaders': {
                    backgroundColor: isNightMode ? '#1f1f1f' : '#f5f5f5',
                    position: 'sticky',
                    top: 0,
                    zIndex: 1,
                  },
                  '& .MuiDataGrid-virtualScroller': {
                    overflow: 'auto !important',
                  },
                  '& .MuiDataGrid-footerContainer': {
                    backgroundColor: isNightMode ? '#1f1f1f' : '#f5f5f5',
                  },
                }}
              />
            </div>
          </ThemeProvider>
          {/* <table className="table">
            <thead className="thead-dark">
              <tr>
                {columns &&
                  columns.map((column, index) => (
                    <th scope="col">{column.label}</th>
                  ))}
                {isAllowDelete || isAllowEdit ? <th>Action</th> : ""}
              </tr>
            </thead>
            <tbody>
              {data && data.length > 0 &&
                data.map((item, index) => (
                  <tr key={index}>
                    {columns &&
                      columns.map((column, index) => (
                        <td>
                          {column.cellContent
                            ? column.cellContent(item)
                            : item[column.key]}
                        </td>
                      ))}
                    <td>
                      {isAllowDelete ? (
                        <span className="me-3">
                          <i className="fa-solid fa-trash"></i>
                        </span>
                      ) : (
                        ""
                      )}
                      {isAllowDelete ? (
                        <span>
                          <i className="fa-solid fa-file-pen"></i>
                        </span>
                      ) : (
                        ""
                      )}
                    </td>
                  </tr>
                ))}

              <tr></tr>
            </tbody>
          </table> */}
        </div>
      </div>
    </div>
  );
};

export default NormalTable;
